// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareStatusDeviceNotConnected_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 18.75C24 21.6495 21.6495 24 18.75 24C15.8505 24 13.5 21.6495 13.5 18.75C13.5 15.8505 15.8505 13.5 18.75 13.5C21.6495 13.5 24 15.8505 24 18.75ZM22 18.75C22 20.5449 20.5449 22 18.75 22C18.2169 22 17.7138 21.8717 17.2699 21.6442L21.6442 17.2699C21.8717 17.7138 22 18.2169 22 18.75ZM15.8557 20.2299L20.2299 15.8557C19.7861 15.6283 19.283 15.5 18.75 15.5C16.9551 15.5 15.5 16.9551 15.5 18.75C15.5 19.283 15.6283 19.7861 15.8557 20.2299Z" fill="#85A1CC"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4H7V17L10 21V23H11V24H13V23.1665C12.1067 22.0051 11.5573 20.5655 11.5042 19H11L9 16.3333V6H15V12.5439C15.6131 12.1726 16.2857 11.8897 17 11.7126V4H16V0H8V4ZM14 2H10V4H14V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareStatusDeviceNotConnected is a generated icon component.
 */
let IconHardwareStatusDeviceNotConnected = IconHardwareStatusDeviceNotConnected_1 = class IconHardwareStatusDeviceNotConnected extends IconBaseElement {
    render() {
        return html `${IconHardwareStatusDeviceNotConnected_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareStatusDeviceNotConnected.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareStatusDeviceNotConnected = IconHardwareStatusDeviceNotConnected_1 = __decorate([
    customElement('zui-icon-hardware-status-device-not-connected')
], IconHardwareStatusDeviceNotConnected);
export { IconHardwareStatusDeviceNotConnected };
